import React, { memo } from "react";
import styled from "styled-components";
import { Button, Col, Row, Tooltip } from "antd";
import { ClearOutlined } from "@ant-design/icons";

import { Select } from "components/Input/Select";
import { UpdateFilterConditionFunctionType } from "hooks/useFilterConditions";

export type FilterConditions = {
  tableName?: string;
  status?: ("active" | "checking" | "inactive")[];
};

const Wrapper = styled(Row).attrs({ gutter: 16 })`
  align-items: center;
  margin-bottom: 16px;
`;

type Props = {
  tableNames: string[];
  hasFilterConditions: boolean;
  filterConditions: FilterConditions;
  updateFilterCondition: UpdateFilterConditionFunctionType<FilterConditions>;
  clearFilterConditions: () => void;
};

export const TableUserFilter = memo<Props>(
  ({
    tableNames,
    hasFilterConditions,
    filterConditions,
    updateFilterCondition,
    clearFilterConditions,
  }) => (
    <Wrapper>
      <Col flex="1 0">
        <Select<string>
          showSearch
          allowClear
          placeholder="テーブル名"
          value={filterConditions.tableName}
          onChange={(tableName) => updateFilterCondition({ tableName })}
          optionFilterProp="label"
          options={tableNames.map((tableName) => ({ label: tableName, value: tableName }))}
        />
      </Col>
      <Col flex="1 0">
        <Select<FilterConditions["status"]>
          mode="multiple"
          allowClear
          placeholder="状態"
          defaultValue={[]}
          value={filterConditions.status ?? []}
          onChange={(status) => updateFilterCondition({ status })}
          optionFilterProp="label"
          options={[
            { label: "アクティブ", value: "active" },
            { label: "会計待ち", value: "checking" },
            { label: "インアクティブ", value: "inactive" },
          ]}
        />
      </Col>
      <Col flex="none">
        <Tooltip title="フィルター条件をクリア">
          <Button
            shape="circle"
            icon={<ClearOutlined />}
            disabled={hasFilterConditions}
            onClick={clearFilterConditions}
          />
        </Tooltip>
      </Col>
    </Wrapper>
  ),
);
